import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO25 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK002-5.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO25
